<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>AR-Assisted Routing and Assembly System</h1>
        </div>
        <div class="video">
          <div class="">
            <video src="../assets/project3.mp4" controls muted playsinline>
            </video>
          </div>
        </div>
        <div class="abstract">
          Aircraft cable systems involve huge quantities and highly complex layouts. At present, wiring is mainly completed through manual blueprint reading, which leads to high error rates, difficult verification, long training cycles for new operators, and high learning costs.
          <br /><br />
          This project was designed and developed for a well-known domestic aviation industry group as an augmented reality-assisted system to reduce both the learning burden and operation cost in complex cable routing tasks.
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_1.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_2.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_4.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_5.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_3.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project3_6.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project3",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
video {
  width: 100%;
}
.video {
  margin-top: 100px;
}
.abstract {
  margin-top: 40px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 4px;
  color: #333333;
}
</style>